import { ref } from 'vue';

export type TypeFn = () => void | Promise<void>;

export default function useQueue() {
  const isRunning = ref<boolean>(false);
  const queue: TypeFn[] = [];

  async function useQueueFn() {
    if (isRunning.value) {
      return;
    }
    isRunning.value = true;

    try {
      while (queue.length) {
        const fn = queue.shift()!;
        try {
          await fn();
        } catch {
          console.error('[QUEUE] Error');
        }
      }
    } finally {
      isRunning.value = false;
      if (queue.length > 0) {
        useQueueFn();
      }
    }
  }

  return {
    add(fn: TypeFn) {
      queue.push(fn);
      useQueueFn();
    },
    clear() {
      queue.length = 0;
    },
    isRunning,
  };
}
